import { createFileRoute } from "@tanstack/react-router"
import Procurement from "~/pages/procurement"
import { usePageTracking } from "~/hooks/usePageTracking"

export const Route = createFileRoute("/_auth/procurement/")({
  component: RouteComponent,
})

function RouteComponent() {
  usePageTracking("Procurement")
  return <Procurement />
}
